var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 21.9921V26.0014H0V22.0067C1.86127 19.5194 4.27721 17.5005 7.05572 16.1108C9.83423 14.7211 12.8987 13.9988 16.0053 14.0014C22.544 14.0014 28.352 17.1401 32 21.9921ZM21.336 6.00008C21.336 7.41457 20.7741 8.77112 19.7739 9.77132C18.7737 10.7715 17.4172 11.3334 16.0027 11.3334C14.5882 11.3334 13.2316 10.7715 12.2314 9.77132C11.2312 8.77112 10.6693 7.41457 10.6693 6.00008C10.6693 4.58559 11.2312 3.22904 12.2314 2.22884C13.2316 1.22865 14.5882 0.666748 16.0027 0.666748C17.4172 0.666748 18.7737 1.22865 19.7739 2.22884C20.7741 3.22904 21.336 4.58559 21.336 6.00008Z",
    fill: "#D1D5DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/DefaultIcon.a6255b5fde952f46727e1e6b6c5ef706.svg";
export { ForwardRef as ReactComponent };